import * as React from 'react';

import { SiteUrls } from '@tableau/shared-urls';

import { cssClass } from '../../style';
import { IViewBase } from '../../ts/models/IViewInfo';
import { DataSources } from '../../ts/resources/Datasources';
import { PageHeaderDataConnectionButton } from '../layout/PageHeaderDataConnectionButton';
import { PageHeaderStyles } from '../layout/PageHeaderStyles';
import { LayoutType } from '../state/LayoutType';
import { DevicePreviewButton } from './breadcrumbs/DevicePreviewButton';

const cssPrefix = 'VizViewerWidgetsBar';

const VizViewerWidgetsBarStyle = cssClass(cssPrefix, 'container', {
  display: 'flex',
  flexWrap: 'nowrap',
  marginRight: 20,
});

const DevicePreviewButtonContainer = cssClass(cssPrefix, 'devicePreviewButtonContainer', {
  marginRight: 20,
  lineHeight: PageHeaderStyles.height,
});

export namespace VizViewerWidgetsBar {
  export interface Props {
    view: IViewBase; // set in VizSpaceProvider
    readonly siteUrls: SiteUrls;
    readonly dataSources: DataSources;
    showDevicePreview: boolean; // set in VizSpaceProvider
    readonly handleDevicePreviewClick?: () => void;
    readonly layoutType: LayoutType;
  }
}

export const VizViewerWidgetsBar: React.SFC<VizViewerWidgetsBar.Props> = ({
  view,
  siteUrls,
  dataSources,
  showDevicePreview,
  handleDevicePreviewClick,
  layoutType,
}) => {
  // TODO: Remove this when the viz viewer and viz previewer pre-resolve the intial view
  // Currently, the VizViewerCtrl and DevicePreviewModal do not resolve the initial view, so when the VizViewerWidgetsBar
  // first renders, the 'view' prop is null. This is in contrast with the other content controllers that pre-resolve
  // the relevant content in the router configuration. We should modify VizViewerCtrl and DevicePreviewModal to do this as
  // well, while considering that the user may be a guest and not have permission to make the getView call.
  if (!view) {
    return null;
  }

  const getDataSourceUrl = (id: string) => siteUrls.datasourceUrl(id);
  const getDataSources = () => dataSources.getByWorkbookId(view.workbook.id).then(list => list.items);
  const displayOnlyIcons = layoutType === 'tablet' || layoutType === 'mobile' || layoutType === 'laptop';

  return (
    <div className={VizViewerWidgetsBarStyle}>
      { showDevicePreview &&
        <span className={DevicePreviewButtonContainer}>
          <DevicePreviewButton handleClick={handleDevicePreviewClick} displayOnlyIcons={displayOnlyIcons}/>
        </span> }

      <PageHeaderDataConnectionButton
        url={siteUrls.workbookDatasourcesUrl(view.workbook.id)}
        getDataSourceUrl={getDataSourceUrl}
        getDataSources={getDataSources}
        displayOnlyIcons={displayOnlyIcons}/>
    </div>
  );
};
